<template>
    <div class="choose-box" ref="chooseBox">
        <header>
            <div class="header-nav">
                <div 
                    class="back" 
                    @click="go('back')"
                >
                    <img src="@/assets/hotel/img/micon/back_cb.png" alt="back">
                </div>
                <div class="search-info">
                    <div @click="go('/hotel/city')"><img src="@/assets/hotel/img/search/position_cg.png" alt="position">{{returnCity}}</div>
                    <div @click="go('/hotel/checkin?timeSelect=1')">
                        <div><span>住</span><span>{{returnDate[0]}}</span></div>
                        <div><span>离</span><span>{{returnDate[1]}}</span></div>
                    </div>
                    <div @click="go('/hotel/search')">
                        <img src="@/assets/hotel/img/search/search_c9.png" alt="search">
                        <span>{{returnValue}}</span>
                    </div>
                </div>
            </div>
            <ChooseBar @send="changeFilters"></ChooseBar>
        </header>
        <main 
            :class="iphonex&&'ios'"
            ref="main"
        >
            <van-list
                v-model="loading"
                @load="onLoad"
                :finished="finished"
                finished-text="没有更多了"
                v-if="status==0"
            >
                <ProductList
                    v-for="(item,index) of productList"
                    :key="index"
                    :setData="item"
                    @toggle="clickHotel(item.hotel_id)"
                ></ProductList>
            </van-list>
            <div 
                class="notMore"
                v-if="status==1"
            >
                <div>
                    <img src="@/assets/hotel/img/micon/404.png" alt="404">
                </div>
                <h3>未找到符合要求的酒店</h3>
                <p>请修改条件后，重新查询</p>
            </div>
            <div 
                class="notFound"
                v-if="status==2"
            >
                <div>
                    <img src="@/assets/hotel/img/micon/network-error-icon.png" alt="error">
                </div>
                <h3>您的网络不太给力，请稍后再试</h3>
                <div @click="reLoad">重新加载</div>
            </div>
        </main>
    </div>
</template>

<script>
import ProductList from '@/pages/hotel/components/product-list.vue'
import ChooseBar from '@/pages/hotel/home/indexComponents/choose-menu.vue'
import { getHotelListData } from '@/pages/hotel/api'
import { mapState,mapMutations } from 'vuex'
    export default {
        components:{
            ProductList,ChooseBar
        },
        data() {
            return {
                loading: false,//加载中状态
                finished: false,//结束状态
                productList:[],//产品列表
                filterParams:{
                    page:1,//页数
                },//筛选条件参数
                status:0,//1无匹配项,2网络错误
                iphonex:false,
                coordinate:{},
                timer:'',
                lock:true,
            }
        },
        computed:{
            ...mapState({
                ckeckinInfo:state => state.hotel.ckeckinInfo,
                searchCity:state => state.hotel.searchCity,
                searchValue:state => state.hotel.searchValue,
            }),
            returnCity(){
                if(this.searchCity.bool){
                    return this.searchCity.name
                }else{
                    return '北京'
                }
            },
            returnDate(){
                let start = new Date(this.ckeckinInfo.start_timeDate);
                let end = new Date(this.ckeckinInfo.end_timeDate);
                return [`${start.getMonth()+1}-${start.getDate()}`,`${end.getMonth()+1}-${end.getDate()}`]
            },
            returnValue(){
                if(this.searchValue.name){
                    return this.searchValue.name
                }else{
                    return '位置/品牌/酒店名'
                }
            }
        },
        mounted() {
            if(sessionStorage.isiOSX){
                this.iphonex = JSON.parse(sessionStorage.isiOSX);
            }
            if(sessionStorage.coordinate){
                this.coordinate = JSON.parse(sessionStorage.coordinate);
                this.filterParams = {...this.filterParams,...this.coordinate}
            }
            if(this.searchValue&&this.searchValue.longitude){
                this.filterParams.area_latitude = this.searchValue.latitude;
                this.filterParams.area_longitude = this.searchValue.longitude;
            }else{
                this.filterParams.search = this.searchValue.name;
            }
            if(this.searchCity.bool){
                this.filterParams.city_code = this.searchCity.value.code;
            }else{
                this.filterParams.city_code = 1;
            }
        },
        methods: {
            ...mapMutations(['setState']),
            onLoad() {
                if(this.lock){
                    this.lock = false;
                }else{
                    return false;
                }
                this.checkOnline();
                if(this.productList[0]!={}){
                    this.productList  = this.productList.concat([{},{},{},{},{},{},{},{},{},{}])
                }
                if(!this.timer){
                    this.timer = setTimeout(()=>{
                        this.productList.splice(this.productList.length-10,10);
                        this.status = 2;
                        clearTimeout(this.timer);
                        this.timer = null; 
                    },10000)
                }
                // 异步更新数据
                getHotelListData(this.filterParams).then((res)=>{
                    this.productList.splice(this.productList.length-10,10);
                    this.productList = this.productList.concat(res.list);
                    this.filterParams.page++;
                    // 加载状态结束
                    this.loading = false;
                    clearTimeout(this.timer);
                    this.timer = null; 
                    this.lock = true;
                    // 数据全部加载完成
                    if (res.list.length < 10) {
                        if(!this.productList.length){
                            this.status = 1;
                        }
                        this.finished = true;
                    }
                    
                }).catch((err)=>{
                    this.lock = true;
                    if(!this.timer){
                        this.status = 2;
                    }
                })
            },
            changeFilters(obj){//改变筛选条件重新触发
                this.filterParams = {...obj};
                this.filterParams.page = 1;
                if(this.searchCity.bool){
                    this.filterParams.city_code = this.searchCity.value.code;
                }else{
                    this.filterParams.city_code = 1;
                }
                if(this.filterParams.area_longitude){
                    this.setState([{name:'searchValue',value:{}}])
                }
                this.filterParams = {...this.filterParams,...this.coordinate};
            
                this.reLoad();
            },
            clickHotel(id){//点击酒店详情
                this.go(`/hotel/detail?hotel_id=${id}`)
            },
            go(path){
                if(path=='back'){
                    this.$router.replace('/hotel/home');
                }else{
                    this.$router.push(path);
                }
            },
            checkOnline(){
                if (navigator.onLine) {
                } else {
                    this.status = 2;
                }
            },
            reLoad(){//重加载
                this.status = 0;
                this.finished = false;
                this.loading = false;
                this.$set(this,'productList',[]);
                setTimeout(()=>{
                    this.onLoad();
                },1)
            },
            clearKeepAlive(){//清除缓存
                if(this.$vnode && this.$vnode.parent && this.$vnode.parent.componentInstance &&this.$vnode.parent.componentInstance.cache){
                    if(this.$vnode.componentOptions){
                        var key = this.$vnode.key == null
                            ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '')
                            : this.$vnode.key;
                        var cache = this.$vnode.parent.componentInstance.cache;
                        var keys  = this.$vnode.parent.componentInstance.keys;

                        if (cache[key]) {
                            if (keys.length) {
                                var index = keys.indexOf(key)
                                if (index > -1) {
                                    keys.splice(index, 1)
                                }
                            }
                            delete cache[key]
                        }
                    }
                }
                this.$destroy();
            }
        },
        watch:{
            'searchCity.bool'(){
                if(this.searchCity.bool){
                    this.filterParams.city_code = this.searchCity.value.code;
                }else{
                    this.filterParams.city_code = 1;
                }
                this.loading = false;
                this.finished = false;
                clearTimeout(this.timer);
                this.timer = '';
                this.lock = true;
                this.status = 0;
                this.filterParams.page = 1;
                this.productList = [];
                this.onLoad();
            },
            'searchCity.name'(newV,oldV){
                if(this.searchCity.bool){
                    this.filterParams.city_code = this.searchCity.value.code;
                }else{
                    this.filterParams.city_code = 1;
                }
                this.loading = false;
                this.finished = false;
                clearTimeout(this.timer);
                this.timer = '';
                this.lock = true;
                this.status = 0;
                this.filterParams.page = 1;
                this.productList = [];
                this.onLoad();
            },
            'searchValue.name'(newV,oldV){
                if(newV!=oldV){
                    if(this.searchValue&&this.searchValue.longitude){
                        this.filterParams.area_latitude = this.searchValue.latitude;
                        this.filterParams.area_longitude = this.searchValue.longitude;
                    }else{
                        this.filterParams.search = this.searchValue.name;
                    }
                    this.loading = false;
                    this.finished = false;
                    clearTimeout(this.timer);
                    this.timer = '';
                    this.lock = true;
                    this.status = 0;
                    this.filterParams.page = 1;
                    this.productList = [];
                    this.onLoad();
                }
            },
        },
        beforeRouteLeave (to, from, next) {//缓存调整
            if(['酒店详情','城市选择','搜索','入住信息'].includes(to.meta.title)){
                this.$route.meta.keepAlive = true;
            }else{
                this.setState([{name:'sortActive',value:0},{name:'positionActive',value:[]},{name:'levelActive',value:null},{name:'filterActive',value:[]}]);
                this.$route.meta.keepAlive = false;
                this.clearKeepAlive();
                this.$route.meta.keepAlive = true;
            }
            next();
        },
    }
</script>
<style lang="less" scoped>
    .choose-box{
        min-height: 100%;
        height: auto;
        background-color: #FBFBFB;
        padding-top: 14rem;
        box-sizing: border-box;
        header {
            padding-top: 4.4rem;
            background-color: #fff;
            box-shadow: 0 0.5rem 1rem 0 rgba(19, 19, 19, 0.03);
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 11;
            .header-nav{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 2.5rem;
                margin: 0rem 0 1rem 0;
                font-size: 0;
                .back{
                    flex: 1;
                    img{
                        width: 1.7rem;
                        height: 1.7rem;
                    }
                }
                .search-info{
                    display: flex;
                    align-items: center;
                    width: 28.3rem;
                    height: 4.5rem;
                    border-radius: 2.25rem;
                    box-shadow: 0 0.5rem 1rem 0 rgba(19, 19, 19, 0.07);
                    padding: 0 1.5rem;
                    box-sizing: border-box;
                    >div:nth-of-type(1){
                        font-size: 1.4rem;
                        font-weight: 400;
                        line-break: 2rem;
                        color: #333333;
                        width: 6rem;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        img{
                            width: 1.2rem;
                            height: 1.4rem;
                            margin-right: 0.5rem;
                            vertical-align: middle;
                        }
                    }   
                    >div:nth-of-type(2){
                        font-size: 1.3rem;
                        line-height: 1.8rem;
                        margin-right: 1rem;
                        span:nth-of-type(1){
                            font-weight: 400;
                            color: #999999;
                            margin-right: 0.5rem;
                        }
                        span:nth-of-type(2){
                            font-weight: 500;
                            color: #108B30;
                        }
                    }
                    >div:nth-of-type(3){
                        display: inline-flex;
                        align-items: center;
                        img{
                            width: 1.6rem;
                            height: 1.6rem;
                            margin-right: 0.3rem;
                        }
                        span{
                            display: inline-block;
                            width: 11.2rem;
                            height: 2rem;
                            font-size: 1.4rem;
                            color: #666666;
                            line-height: 2rem;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow:hidden;
                        }
                    }
                }
            }
        }
        main{
            &.ios{
                padding-bottom: 3.4rem;
            }
            .notMore{
                div{
                    text-align: center;
                    img{
                        width: 20rem;
                        height: 20rem;
                        margin-top: 8rem;
                    } 
                }
                
                h3{
                    font-size: 1.7rem;
                    font-weight:400;
                    color: #181818;
                    line-height: 2.4rem;
                    margin:3rem 0 0.5rem 0;
                    text-align: center;
                }
                p{
                    font-size: 1.5rem;
                    font-weight:400;
                    color: #999999;
                    line-height: 2.1rem;
                    text-align: center;
                }
            }
            .notFound{
                div{
                    text-align: center;
                    img{
                        width: 20rem;
                        height: 20rem;
                        margin-top: 8rem;
                    }
                }
                div:nth-of-type(2){
                    margin: 0 auto;
                    width: 13rem;
                    height: 4rem;
                    line-height: 4rem;
                    font-size: 1.6rem;
                    font-weight: 500;

                    color: #fff;
                    background: linear-gradient(90deg,#0FBF6D,#108B30);
                    border-radius: 2.25rem;
                }
                h3{
                    font-size: 1.7rem;
                    font-weight:400;
                    color: #181818;
                    line-height: 2.4rem;
                    margin:3rem 0 2rem 0;
                    text-align: center;
                }
                p{
                    font-size: 1.5rem;
                    font-weight:400;
                    color: #999999;
                    line-height: 2.1rem;
                    text-align: center;
                }
            }
        }
    }
    .noscroll{
        touch-action: none;
        overflow: hidden;
    }
</style>